import { render } from "./FindOrCreateClient.vue?vue&type=template&id=beac8440"
import script from "./FindOrCreateClient.vue?vue&type=script&lang=js"
export * from "./FindOrCreateClient.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Desktop/projects/ConexionCreativa/rg-business/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__